import { createFileRoute } from '@tanstack/react-router';
import { ReportBuilderPage } from '../../features/reports/builder/ReportBuilderPage.jsx';

export const Route = createFileRoute('/_app/reports/new')({ component: () => <ReportBuilderPage /> });
